import axios from 'axios'
import eventBus from '@utils/eventBus';
import Utils from '@utils/utils';
import { message } from 'antd';
import * as _ from "underscore";

const preproductionBaseUrl = `http://canary.ps.arcsoftbiz.com` // 灰度版本 staging
const productionBaseUrl = `https://photostudio.arcsoft.com.cn` // 上线版本 production

// const devBaseUrl = `http://canary.ps.arcsoftbiz.com` // 灰度 development
const devBaseUrl = `http://172.17.13.140:8083` // 测试 development

const url = (process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'test') ?
    devBaseUrl :
    process.env.NODE_ENV == 'staging' ?
        preproductionBaseUrl :
        productionBaseUrl

const upload = "/aishops/common/upload"
const uploadImage = "/aishops/common/uploadImage";
const uploadImageWithToken = "/aishops/common/uploadImageWithToken"
const maskPredictionAicloth = "/aishops/aicloth/mask/prediction";
const maskPredictionAidressform = "/aishops/aidressform/mask/prediction";
const maskPrediction = "/aishops/aimodel/mask/prediction";
const maskPredictionGoods = "/aishops/aigods/mask/prediction";
const inpaintPrediction = "/aishops/aimodel/inpaint/prediction";
const inpaintPredictionGoods = "/aishops/aigods/inpaint/prediction";
const aidressformPrediction = "/aishops/aidressform/inpaint/prediction";
const virtualtryonPrediction = "/aishops/aivirtualtryon/handle/prediction" // virtualtryon功能测试
const handlePrediction = "/aishops/aiautocrop/handle/prediction";
const aiembeddingPrediction = "/aishops/aiembedding/mask/prediction"; //sam
const aiinteractivePrediction = "/aishops/aiinteractive/mask/prediction"; //交互式分割
const airemovePrediction = "/ps/web/algo/magicEraser"; //擦除 修复
const aisuperresolutionPrediction = "/aishops/aisuperresolution/handle/prediction"; // 图片sr
const aisuperresolution4VideoPrediction = "/ps/web/algo/videoSR/predict"; // 视频sr
const aibeautyPredictionUrl = "/aishops/aibeauty/handle/prediction" // 一键梅花算法
const getTaskListByUserUrl = '/ps/web/project/getTaskListByUser'; // 获取用户的任务队列，不需要参数
const getTaskInfoUrl = '/ps/web/project/getTaskInfo'; // “快速生成” 或 “重新生成”时，调用此接口获取当前任务相关的所有参数
const deleteTaskImageUrl = '/ps/web/project/task/remove'; // 删除单张结果图
const getAllProjectListUrl = '/ps/web/project/list';
const getAllFavoriteListUrl = '/ps/web/project/listBookmarkTask'
const getProjectDetailUrl = '/ps/web/project/details';
const deleteProjectUrl = '/ps/web/project/remove';
const renameProjectUrl = '/ps/web/project/rename';
const setProjectReadFlagUrl = '/ps/web/project/setProjectReadFlag'
const modelTryOnList = '/ps/web/material/modelTryOn';
const modelPersonList = '/ps/web/material/modelPerson';
const modelBackgroundList = '/ps/web/material/modelBackground';
const tryonBackgroundList = '/ps/web/material/modelTryOnBackground';
const commodityBackgroundList = '/ps/web/material/commodityBackground';
const commodityShowcaseList = '/ps/web/material/commodityShowcase';
const projectCreate = '/ps/web/project/save';
const aiDragGanUrl = '/aishops/aidraggan/handle/prediction';
const setProjectMainPicUrl = '/ps/web/project/setMainImage';
const picBatchMoveUrl = '/ps/web/project/task/batchRemove';
const projectBatchMoveUrl = '/ps/web/project/batchRemove';
const projectDownloadUrl = '/ps/web/project/download';
const projectBatchDownloadUrl = '/ps/web/project/batchDownload';
const favorBatchDownloadUrl = '/ps/web/project/downloadBookmarkImage'
const userSendCode = '/ps/web/user/sendCode';
const userLogin = '/ps/web/user/login';
const emailRegister = '/ps/web/user/emailRegister';
const orderPlans = '/ps/web/order/plans';
const orderPlansByType = '/ps/web/order/plansByType'
const orderPlanDetails = '/ps/web/order/planDetails'
const paymentOrderStatusUrl = '/ps/web/order/paymentOrderStatus'
const powerPackages = '/ps/web/order/powerPackages';
const subscribePlan = '/ps/web/order/subscribePlan';
const subscribeWithoutOrder = '/ps/web/order/subscribeWithoutOrder';
const userInfo = '/ps/web/user/userInfo';
const getMembershipList = '/ps/web/order/getMembershipList'
const getOrderList = '/ps/web/order/getOrderList';
const getUsageBillList = '/ps/web/order/getUsageBillList'
const subscribePowerPackage = '/ps/web/order/subscribePowerPackage';
const subscribePowerPackageWithoutOrder = '/ps/web/order/subscribePowerPackageWithoutOrder';
const payForOrder = '/ps/web/order/payForOrder';
const removeOrder = '/ps/web/order/removeOrder';
const checkVerifyCodeUrl = '/ps/web/user/checkVerifyCode'
const changeMobileUrl = '/ps/web/user/changeMobile'
const setPasswordUrl = '/ps/web/user/setPassword'
const logout = '/ps/web/user/logout';
const getTaskImages = '/ps/web/project/getTaskImages';
const getHDImage = '/ps/web/project/getHDImage';
const setHDImage = '/ps/web/project/setHDImage';
const getClothesCategoryListUrl = '/ps/web/material/modelClothesCategoryList' // 获取模特服饰分类树
const getVersionUrl = '/ps/web/version'
const bookmarkTaskUrl = '/ps/web/project/task/bookmark'
const setSaleCodeUrl = '/ps/web/user/setSalesCode'
const completeInfoUrl = '/ps/web/user/completeInfo'
const getPowerBalance = '/ps/web/user/powerBalance'
const uploadResource = '/ps/web/user/uploadResource'
const feedback = '/ps/web/user/feedback'
const useroplog = '/ps/web/user/oplog'
const forgetPassword = '/ps/web/user/forgetPassword'
const scoreImage = '/ps/web/project/scoreImage'
const saveCustomTryOnModelUrl = '/ps/web/material/saveCustomTryOn' // 自定义tryOn添加
const removeCustomTryOnModelUrl = '/ps/web/material/removeCustomTryOn' // 自定义tryOn删除
const showcaseList = '/ps/web/project/showcaseList'
const saveCustomMaterialUrl = '/ps/web/material/saveCustomMaterial'
const removeCustomMaterialUrl = '/ps/web/material/removeCustomMaterial'
const taobaoOauth = '/ps/web/user/third/taobao/oauth'
const setCmRead = '/ps/web/user/setCmRead'
const userAppeal = '/ps/web/user/appeal'
const orderCustomPlan = '/ps/web/order/customPlan'
const unregisterUser = '/ps/mobile/unregisterUser'
const usercaptcha = '/ps/web/user/captcha'
const bgCategoryList = '/ps/web/material/bgCategoryList' // 商品背景列表
const image2Text = '/ps/web/algo/image2Text' // 图生文字
const savePrompt = '/ps/web/material/savePrompt' // 保存参考图prompt
const listOrder = '/ps/web/merchant/listOrder' //大客户交付
const getOrderDetails = '/ps/web/merchant/getOrderDetails' //大客户需求页详细数据
const confirmOrder = '/ps/web/merchant/confirmOrder' //大客户-确认拒绝订单
const listWithSku = '/ps/web/merchant/listWithSku' //大客户交付页订单列表
const listArtifactsBySku = '/ps/web/merchant/listArtifactsBySku' //根据sku获取成片图
const dashboardInfo = '/ps/web/merchant/dashboardInfo' //大客户需求页统计数据
const merchantdownload = '/ps/web/merchant/download'
const merchantdownloadBatch = '/ps/web/merchant/downloadBatch'
const merchantrefine = '/ps/web/merchant/refine'

// 模特视频
const modelvideoList = '/ps/web/material/videoTryOn'
const videoTryonImageCheck = '/ps/web/videoTryonImageCheck'
const doTryonVideo = '/ps/web/algo/doTryonVideo'
const saveVideoMaterial = '/ps/web/material/saveVideoMaterial'

// 商品视频生成
const commodityVideoPredictUrl = '/ps/web/algo/doCommodityVideo'

// 优惠券模块
const acquireCouponUrl = '/ps/web/coupon/acquireCoupon' // 优惠券领取
const changeCouponUrl = '/ps/web/coupon/changeCoupon' // 优惠券兑换 
const getOneCouponUrl = '/ps/web/coupon/getOne' // 获取单张券码信息
const getCouponListForPayUrl = '/ps/web/coupon/listPayCouponSelect' // 支付页优惠下拉列表
const getCouponListUrl = '/ps/web/coupon/listCouponPage' // 用户优惠券列表

// 微信登录
const wechatQrcode = '/ps/web/user/third/wechat/qrcode'
const loginStatus = '/ps/web/user/third/wechat/qr/loginStatus'
const bindStatus = '/ps/web/user/third/wechat/qr/bindStatus'
const unbind = '/ps/web/user/third/wechat/qr/unbind'

// 下载&高清下载
const commonDownloadUrl = '/ps/web/project/commonDownload'
const hdDownloadUrl = '/ps/web/project/srDownload'
const aiEditDownloadUrl = '/ps/web/project/aiEditDownload'

// 人脸检测
const personCheckUrl = '/ps/web/personCheck'
const multiSemanticPredictionUrl = '/ps/web/algo/multiSemantic'

// 活动
const activityInviteInfo = '/ps/web/activity/activityInviteCashbackInfo' // 活动邀请情况
const inviteRecords = '/ps/web/activity/listInviteRecords' // 返现记录
const withdrawalRecords = '/ps/web/activity/listWithdrawalRecords' // 提现记录
const handleWithdrawal = '/ps/web/activity/withdrawal' // 提现操作

const getCommodityCategoryUrl = '/ps/web/algo/getCategory' // 根据mask获取商品分类

const generateConstantIdUrl = '/ps/web/algo/generateConstantId' // 创建ConstantId

const getWebdoSr = '/ps/web/doSr' // 获取algoId

// 鞋子上脚
const getmodelShoesTryOnList = '/ps/web/material/modelShoesTryOn';
const maskPredictionshoes = "/ps/web/algo/shoesMask";
const doShoesTryon = '/ps/web/algo/doShoesTryon'
const shoesCategoryList = '/ps/web/material/categoryList'
const categoryList = '/ps/web/material/v2/categoryList'
const saveCustomShoesTryOn = '/ps/web/material/saveCustomShoesTryOn'
const saveHsfModel = '/ps/web/material/saveHsfModel'

// 自定义模特
const materialread = '/ps/web/material/read'

const instance = axios.create({
    baseURL: url
});

// 添加请求拦截器
instance.interceptors.request.use(config => {
    const token = localStorage.getItem('token')
    config.headers['Ps-Auth-Token'] = token
    // if (config.method === 'get' && config.params && !(config.params instanceof URLSearchParams)) {
    //     config.url = encodeURIParams(config)
    // }
    return config
})

const unauthorizedMessage = _.debounce((msg) => {
    const token = localStorage.getItem('token')
    if (token) message.warning('凭证已过期，请重新登录')
    if (Utils.isMobileDevice()) {
        window.location.reload()
    }
    else message.warning('请先登录账号！')
    localStorage.removeItem('token')
    Utils.clearAllTaskCache()
    eventBus.emit('tokenExpired', { pathname: location.pathname })
}, 500)

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
    // console.log('axios.interceptors.response', response)
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    if (response.data?.code == -4001 || response.data?.code == -5023) {
        response.data.message = "" // 将message置空，避免多次弹出未授权消息框
        unauthorizedMessage()
    }
    return response
}, function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    console.log('axios.interceptors.response error', error)
    return Promise.reject(error);
})

function getFun(url) {
    return function (params) {
        return new Promise(function (resolve, reject) {
            if (params instanceof URLSearchParams) {
                params.append("ts", new Date().getTime())
            } else {
                if (params) params = { ...params, ts: new Date().getTime() }
                else params = { ts: new Date().getTime() }
            }
            instance.get(
                url,
                { params }
            ).then(function (res) {
                if (res.status >= 200 && res.status < 300) {
                    resolve(res.data)
                }
            }).catch((error) => {
                reject(error)
            })
        })
    }
}

function postFun(url) {
    return function (data, params) {
        return new Promise(function (resolve, reject) {
            if (params instanceof URLSearchParams) {
                params.append("ts", new Date().getTime())
            } else {
                if (params) params = { ...params, ts: new Date().getTime() }
                else params = { ts: new Date().getTime() }
            }
            instance.post(
                url,
                data,
                { params }
            ).then(function (res) {
                if (res.status >= 200 && res.status < 300) {
                    resolve(res.data)
                }
            }).catch((error) => {
                reject(error)
            })
        })
    }
}

function putFun(url) {
    return function (data, params) {
        return new Promise(function (resolve, reject) {
            if (params instanceof URLSearchParams) {
                params.append("ts", new Date().getTime())
            } else {
                if (params) params = { ...params, ts: new Date().getTime() }
                else params = { ts: new Date().getTime() }
            }
            instance.put(
                url,
                data,
                { params }
            ).then(function (res) {
                if (res.status >= 200 && res.status < 300) {
                    resolve(res.data)
                }
            }).catch((error) => {
                reject(error)
            })
        })
    }
}

function deleteFun(url) {
    return function (data, params) {
        return new Promise(function (resolve, reject) {
            if (params instanceof URLSearchParams) {
                params.append("ts", new Date().getTime())
            } else {
                if (params) params = { ...params, ts: new Date().getTime() }
                else params = { ts: new Date().getTime() }
            }
            instance.delete(
                url,
                { data, params }
            ).then(function (res) {
                if (res.status >= 200 && res.status < 300) {
                    resolve(res.data)
                }
            }).catch((error) => {
                reject(error)
            })
        })
    }
}

export function commonApiInvoker(apiPromise, setLoading, rejectAccept) {
    return new Promise((resolve, reject) => {
        setLoading && setLoading(true)
        return apiPromise.then(res => {
            if (res.code != 200 && res.code != 0) throw new Error(res.message)
            resolve(res.data)
        }).catch(err => {
            console.error(err.message)
            message.warning(err.message)
            rejectAccept && reject(err)
        }).finally(() => {
            setLoading && setLoading(false)
        })
    })
}

export default {
    commonApiInvoker: commonApiInvoker,
    upload: postFun(upload),
    uploadImage: postFun(uploadImage),
    uploadImageWithToken: postFun(uploadImageWithToken),
    maskPrediction: postFun(maskPrediction),
    maskPredictionAicloth: postFun(maskPredictionAicloth),
    maskPredictionAidressform: postFun(maskPredictionAidressform),
    maskPredictionGoods: postFun(maskPredictionGoods),
    maskMultiSemanticPrediction: postFun(multiSemanticPredictionUrl),
    inpaintPrediction: postFun(inpaintPrediction),
    getInpaintPredictionById: (id) => postFun(`${inpaintPrediction}/${id}`)(),
    aiinteractivePrediction: postFun(aiinteractivePrediction),
    inpaintPredictionGoods: postFun(inpaintPredictionGoods),
    aidressformPrediction: postFun(aidressformPrediction),
    virtualtryonPrediction: postFun(virtualtryonPrediction),
    aiembeddingPrediction: postFun(aiembeddingPrediction),
    airemovePrediction: postFun(airemovePrediction),
    handlePrediction: postFun(handlePrediction),
    aisuperresolutionPrediction: postFun(aisuperresolutionPrediction),
    aisuperresolution4VideoPrediction: postFun(aisuperresolution4VideoPrediction),
    aibeautyPrediction: postFun(aibeautyPredictionUrl),
    getTaskListByUser: getFun(getTaskListByUserUrl),
    getTaskInfo: getFun(getTaskInfoUrl),
    deleteTaskImage: postFun(deleteTaskImageUrl),
    getAllProjectList: getFun(getAllProjectListUrl),
    getAllFavoriteList: getFun(getAllFavoriteListUrl),
    getProjectDetail: getFun(getProjectDetailUrl),
    deleteProject: postFun(deleteProjectUrl),
    renameProeject: postFun(renameProjectUrl),
    setProjectReadFlag: postFun(setProjectReadFlagUrl),
    modelTryOnList: getFun(modelTryOnList),
    modelPersonList: getFun(modelPersonList),
    modelBackgroundList: getFun(modelBackgroundList),
    tryonBackgroundList: getFun(tryonBackgroundList),
    commodityBackgroundList: getFun(commodityBackgroundList),
    commodityShowcaseList: getFun(commodityShowcaseList),
    projectCreate: postFun(projectCreate),
    aiDragGan: postFun(aiDragGanUrl),
    setProjectMainPic: postFun(setProjectMainPicUrl),
    picBatchMove: postFun(picBatchMoveUrl),
    projectBatchMove: postFun(projectBatchMoveUrl),
    projectDownload: postFun(projectDownloadUrl),
    projectPatchDownload: postFun(projectBatchDownloadUrl),
    favorBatchDownload: postFun(favorBatchDownloadUrl),
    userSendCode: data => postFun(userSendCode)({ ...data, platform: sessionStorage.getItem('platform') }),
    userLogin: data => postFun(userLogin)({ ...data, platform: sessionStorage.getItem('platform'), sourceId: sessionStorage.getItem('sourceId'), device: Utils.isMobileDevice() ? 'web_mobile' : 'web_pc', authCode: sessionStorage.getItem('code') }),
    emailRegister: data => postFun(emailRegister)({ ...data, platform: sessionStorage.getItem('platform'), sourceId: sessionStorage.getItem('sourceId'), device: Utils.isMobileDevice() ? 'web_mobile' : 'web_pc', authCode: sessionStorage.getItem('code') }),
    orderPlans: getFun(orderPlans),
    orderPlansByType: getFun(orderPlansByType),
    orderPlanDetails: getFun(orderPlanDetails),
    paymentOrderStatus: postFun(paymentOrderStatusUrl),
    powerPackages: getFun(powerPackages),
    subscribePlan: data => postFun(subscribePlan)({ ...data, sourceId: sessionStorage.getItem('sourceId') }),
    subscribeWithoutOrder: data => postFun(subscribeWithoutOrder)({ ...data, sourceId: sessionStorage.getItem('sourceId') }),
    userInfo: getFun(userInfo),
    getMembershipList: getFun(getMembershipList),
    getOrderList: getFun(getOrderList),
    getUsageBillList: getFun(getUsageBillList),
    subscribePowerPackage: data => postFun(subscribePowerPackage)({ ...data, sourceId: sessionStorage.getItem('sourceId') }),
    subscribePowerPackageWithoutOrder: data => postFun(subscribePowerPackageWithoutOrder)({ ...data, sourceId: sessionStorage.getItem('sourceId') }),
    payForOrder: postFun(payForOrder),
    removeOrder: postFun(removeOrder),
    checkVerifyCode: data => postFun(checkVerifyCodeUrl)({ ...data, platform: sessionStorage.getItem('platform') }),
    changeMobile: data => postFun(changeMobileUrl)({ ...data, platform: sessionStorage.getItem('platform') }),
    setPassword: postFun(setPasswordUrl),
    logout: postFun(logout),
    getTaskImages: getFun(getTaskImages),
    getHDImage: getFun(getHDImage),
    setHDImage: postFun(setHDImage),
    getClothesCategoryList: getFun(getClothesCategoryListUrl),
    getVersion: getFun(getVersionUrl),
    bookmarkTask: postFun(bookmarkTaskUrl),
    setSaleCode: postFun(setSaleCodeUrl),
    completeInfo: postFun(completeInfoUrl),
    getPowerBalance: getFun(getPowerBalance),
    uploadResource: postFun(uploadResource),
    feedback: postFun(feedback),
    useroplog: postFun(useroplog),
    forgetPassword: data => postFun(forgetPassword)({ ...data, platform: sessionStorage.getItem('platform') }),
    scoreImage: postFun(scoreImage),
    saveCustomTryOnModel: postFun(saveCustomTryOnModelUrl), // 自定义tryOn添加
    saveCustomMaterialv2: postFun('/ps/web/material/v2/saveCustomMaterial'),
    removeCustomTryOnModel: postFun(removeCustomTryOnModelUrl), // 自定义tryOn删除
    showcaseList: data => getFun(showcaseList)({ ...data, sourceId: sessionStorage.getItem('sourceId') }),
    saveCustomMaterial: postFun(saveCustomMaterialUrl),
    removeCustomMaterial: postFun(removeCustomMaterialUrl),
    setCmRead: postFun(setCmRead),
    userAppeal: postFun(userAppeal),
    orderCustomPlan: getFun(orderCustomPlan),
    unregisterUser: postFun(unregisterUser),
    usercaptcha: postFun(usercaptcha),
    bgCategoryList: getFun(bgCategoryList),
    image2Text: postFun(image2Text),
    savePrompt: postFun(savePrompt),

    // 模特视频
    modelvideoList: getFun(modelvideoList),
    videoTryonImageCheck: postFun(videoTryonImageCheck),
    doTryonVideo: postFun(doTryonVideo),
    saveVideoMaterial: postFun(saveVideoMaterial),

    // 商品视频生成
    commodityVideoPrediction: postFun(commodityVideoPredictUrl),

    // 优惠券模块
    acquireCoupon: postFun(acquireCouponUrl), // 优惠券领取
    changeCoupon: postFun(changeCouponUrl), // 优惠券兑换
    getOneCoupon: getFun(getOneCouponUrl),
    getCouponListForPay: getFun(getCouponListForPayUrl),
    getCouponList: getFun(getCouponListUrl),

    // 普通下载和高清下载
    commonDownload: postFun(commonDownloadUrl),
    hdDownload: postFun(hdDownloadUrl),
    aiEditDownload: postFun(aiEditDownloadUrl),

    wechatQrcode: postFun(wechatQrcode),
    loginStatus: data => postFun(loginStatus)({ ...data, platform: sessionStorage.getItem('platform'), device: Utils.isMobileDevice() ? 'web_mobile' : 'web_pc', authCode: sessionStorage.getItem('code') }),
    bindStatus: data => postFun(bindStatus)({ ...data, platform: sessionStorage.getItem('platform') }),
    unbind: postFun(unbind),
    taobaoOauth: postFun(taobaoOauth),

    // 人脸检测
    personCheck: postFun(personCheckUrl),
    // 多语义分割
    multiSemanticPrediction: postFun(multiSemanticPredictionUrl),

    // 活动
    activityInviteInfo: getFun(activityInviteInfo),
    inviteRecords: getFun(inviteRecords),
    withdrawalRecords: getFun(withdrawalRecords),
    handleWithdrawal: postFun(handleWithdrawal),

    // 根据mask获取商品分类
    getCommodityCategory: postFun(getCommodityCategoryUrl),
    generateConstantId: postFun(generateConstantIdUrl),

    //大客户交付
    listOrder: getFun(listOrder), //需求页订单列表
    getOrderDetails: getFun(getOrderDetails), //订单详情
    confirmOrder: postFun(confirmOrder),//确认、拒绝订单
    listWithSku: getFun(listWithSku), //交付页订单列表
    listArtifactsBySku: getFun(listArtifactsBySku),//根据sku获取成片图
    dashboardInfo: getFun(dashboardInfo),//需求页统计数据
    merchantdownload: postFun(merchantdownload),
    merchantdownloadBatch: postFun(merchantdownloadBatch),
    merchantrefine: postFun(merchantrefine),
    getWebdoSr: postFun(getWebdoSr),

    // 鞋子上脚
    getmodelShoesTryOnList: getFun(getmodelShoesTryOnList),
    maskPredictionshoes: postFun(maskPredictionshoes),
    doShoesTryon: postFun(doShoesTryon),
    categoryList: getFun(categoryList),
    shoesCategoryList: getFun(shoesCategoryList),
    saveCustomShoesTryOn: postFun(saveCustomShoesTryOn),
    saveHsfModel: postFun(saveHsfModel),

    // 自定义模特
    materialread: postFun(materialread),

    // 商品换色
    tasksInpaint: postFun(`/ps/web/algo/commodityRecolor`),
    doCommodityRecolor: postFun(`/ps/web/algo/doCommodityRecolor`),
    gettasksInpaintResultLoop: id => postFun(`/ps/web/algo/commodityRecolor/${id}`)(),

    // 交互式迁移
    shoesMaskPredict: postFun(`/ps/web/algo/shoesMask`),
    loopShoesMaskPredict: id => postFun(`/ps/web/algo/shoesMask/${id}`)(),
    interactiveMaskPredict: postFun(`/aishops/aiinteractive/mask/prediction`),
    loopInteractiveMaskPredict: id => postFun(`/aishops/aiinteractive/mask/prediction/${id}`)(),

    // 高清改尺寸
    doSrResize: postFun(`/ps/web/doSrResize`),
    loopDoSrResize: id => postFun(`/ps/web/srResize/${id}`)(),

    // 推荐tryon
    modelTryOnRecommend: postFun(`/ps/web/material/modelTryOnRecommend`),

    // 服务助手
    createWorkflowTask: postFun(`/ps/web/workflow/task`), // 创建任务
    getWorkflowTaskList: getFun(`/ps/web/workflow/task`), // 查询任务
    updateWorkflowTask: (id, data) => putFun(`/ps/web/workflow/task/${id}`)(data), // 编辑任务
    submitWorkflowTask: (id, data) => postFun(`/ps/web/workflow/task/${id}/submit`)(data), // 提交任务
    getWorkflowTask: id => getFun(`/ps/web/workflow/task/${id}`)(), // 根据id查询任务详情
    appendSkuToWorkflowTask: postFun(`/ps/web/workflow/task/sku`), // 添加源素材到具体任务
    readWorkflowTask: id => putFun(`/ps/web/workflow/task/${id}/read`)(), // 任务已读
    deleteWorkflowTask: id => deleteFun(`/ps/web/workflow/task/${id}`)(), // 删除任务
    getWorkflowFreeUsage: getFun(`/ps/web/workflow/freeUsage`), // 获取用户限免用量
    getClothType: postFun(`/ps/web/common/clothing/classify`), // 衣服分类器
    bindMobileOrCompany: postFun(`/ps/web/user/bindMobileOrCompany`), // 衣服分类器
    // 服务助手（资源管理）
    getPresetResources: getFun(`/ps/web/workflow/resource/default`), // 查询预置资源
    getCustomResources: getFun(`/ps/web/workflow/resource/custom`), // 查询自定义资源
    getFavoriteResources: getFun(`/ps/web/workflow/resource/favorite`), // 查询收藏资源
    removeCustomResources: deleteFun(`/ps/web/workflow/resource/custom`), // 删除自定义资源
    favoriteResource: postFun(`/ps/web/workflow/resource/favorite`), // 添加收藏资源
    unfavoriteResource: deleteFun(`/ps/web/workflow/resource/favorite`), // 取消收藏资源
    workflowdownload: postFun(`/ps/web/workflow/batch/download`), // 取消收藏资源
    // 交付数据
    listDeliveryByVersion: getFun(`/ps/web/psai/listDeliveryByVersion`), // 交付数据
    deliveryJudge: postFun(`/ps/web/psai/judge`), // 验收交付图片

    // v3.0新的素材接口
    getPresetResources2: getFun(`/ps/web/material/v2/listDefault`), // 查询预置资源
    getCustomResources2: getFun(`/ps/web/material/v2/listCustom`), // 查询自定义资源
    getFavoriteResources2: getFun(`/ps/web/material/v2/listFavorites`), // 查询收藏资源
    getTryonModelRecommend: postFun(`/ps/web/material/v2/modelTryOnRecommend`), // 查询推荐试穿模型
    favoriteResource2: postFun(`/ps/web/material/v2/bookmark`), // 添加收藏资源
    unfavoriteResource2: postFun(`/ps/web/material/v2/unBookmark`), // 取消收藏资源
    getFavoriteColors: getFun(`/ps/web/material/v2/listBookmarkColor`), // 查询收藏颜色
    favoriteColor: postFun(`/ps/web/material/v2/bookmarkColor`), // 收藏颜色
    unfavoriteColor: postFun(`/ps/web/material/v2/unBookmarkColor`), // 取消收藏颜色
    saveMaterialPreference: postFun(`/ps/web/material/v2/saveMaterialPreference`), // 编辑素材mask

    // v3.0生成接口
    doTryonInpaint: postFun(`/ps/web/v2/doTryOn`), // AI TryOn
    doPoseTryonInpaint: postFun(`/ps/web/v2/doPoseFantasy`), // 姿势裂变生成
    doModelInpaint: postFun(`/ps/web/v2/doModelInpaint`), // AI 模特
    doShoesTryonInpaint: postFun(`/ps/web/v2/doShoesTryOn`), // AI 鞋子试穿
    doVideoTryonInpaint: postFun(`/ps/web/v2/doVideoTryOn`), // AI 视频试穿
    doCommodityInpaint: postFun(`/ps/web/v2/doCommodityInpaint`), // AI 商品
    doCommodityRecolorInpaint: postFun(`/ps/web/v2/doCommodityRecolor`), // 商品换色
    doClothRecolorInpaint: postFun(`/ps/web/v2/doClothRecolor`), // 服饰换色
    doGlassesTryonInpaint: postFun(`/ps/web/v2/doGlassesTryOn`), // 眼镜试戴
    doSimTryonInpaint: postFun(`/ps/web/v2/doSimTryOn`), // 同版型试衣

    // 我的项目-v3
    listProjectv2: getFun(`/ps/web/project/v2/listProject`), // 项目列表
    getProjectDetailv2: getFun(`/ps/web/project/v2/getProjectDetail`), // 项目详情列表
    batchRemoveTaskv2: postFun(`/ps/web/project/v2/batchRemoveTask`), // 批量删除生成结果
    batchDownloadByTaskv2: postFun(`/ps/web/project/v2/batchDownloadByTask`), // 批量下载Task图
    listRecentProjectv2: getFun(`/ps/web/project/v2/listRecentProject`), //  任务列表
    doHDv2: postFun(`/ps/web/v2/doHD`), // 高清下载
    queryHDStatusv2: postFun(`/ps/web/project/v2/queryHDStatus`), // 高清结果轮询
    listBookmarkTaskv2: getFun(`/ps/web/project/v2/listBookmarkTask`), // 我的收藏
    getTaskInfoV2: getFun(`/ps/web/project/v2/getTaskInfo`), // 任务详情
    getTaskRequestParam: getFun(`/ps/web/project/v2/getRequestParam`), // 获取任务参数

    // 搭配上身提示词
    getAlgoPrompt: postFun(`/ps/web/algo/prompt`),
    doFusionWear: postFun(`/ps/web/v2/doFusionWear`), // 生成搭配上身

    // AI编辑
    doHandFixv2: postFun(`/ps/web/v2/doHandFix`), // 手部修复
    doMagicErasev2: postFun(`/ps/web/v2/doMagicErase`), // 魔法擦除
    saveResultToProjectv2: postFun(`/ps/web/project/v2/saveResultToProject`), // 保存AI编辑结果
    generateMetadatav2: postFun(`/ps/web/v2/generateMetadata`), // 添加图片元信息

    // 合规水印下载弹窗flag
    agreeDownloadNoLogov2: postFun(`/ps/web/user/agreeDownloadNoLogo`),

    // 营销弹窗
    listPopupv2: getFun(`/ps/web/popup/v2/listPopup`),

    // 企业管理
    getUserOrgInfo: getFun(`/ps/web/user/getUserOrgInfo`), //用户企业信息
    postSaveOrg: postFun(`/ps/web/user/saveOrg`), // 新建、编辑企业
    postChangeOrg: postFun(`/ps/web/user/changeOrg`), // 切换企业账号
    getListPlan: getFun(`/ps/web/order/listPlan`), // 套餐列表
    postSubscribePlan: postFun(`/ps/web/order/subscribePlan`), // 套餐订阅
    postSubscribePowerOrMember: postFun(`/ps/web/order/subscribePowerOrMember`), // 加油包
    postChangeAllocateMode: postFun(`/ps/web/user/changeAllocateMode`), // 改变虹豆分配模式
    generateInvitingLink: postFun(`/ps/web/user/generateInvitingLink`), // 生成邀请链接
    postJoinOrg: postFun(`/ps/web/user/joinOrg`), // 加入企业
    getListOrgMember: getFun(`/ps/web/user/listOrgMember`), // 企业成员列表
    updateNickName: postFun(`/ps/web/user/updateNickName`), // 更新用户昵称
    removeMember: postFun(`/ps/web/user/removeMember`), // 移除企业成员
    listOrgPowerUsageStat: getFun(`/ps/web/user/listOrgPowerUsageStat`), // 企业虹豆明细一级table
    listOrgPowerUsageStatDetail: getFun(`/ps/web/user/listOrgPowerUsageStatDetail`), // 企业虹豆明细二级table
    listUserOrgVip: getFun(`/ps/web/user/listUserOrgVip`), // 企业成员额度列表
    postAllocatePower: postFun(`/ps/web/user/allocatePower`), // 企业成员额度列表
    confirmAgreement: postFun(`/ps/web/user/confirmAgreement`), // 企业成员额度列表
    batchRemoveProject: postFun(`/ps/web/project/batch/removeProject`), // 删除项目

    // 企业版生图
    addProject: postFun(`/ps/web/project/batch/addProject`), //创建项目
    listSkuByProject: getFun(`/ps/web/project/batch/listSkuByProject`),
    batchSaveSku: postFun(`/ps/web/project/batch/saveSku`),
    batchRemoveSku: postFun(`/ps/web/project/batch/removeSku`),
    batchUpdateProject: postFun(`/ps/web/project/batch/updateProject`), //编辑项目名
    batchStartProject: postFun(`/ps/web/project/batch/startProject`), //发起项目
    listBatchProject: getFun(`/ps/web/project/batch/listBatchProject`), //项目列表
    batchResetUnread: postFun(`/ps/web/project/batch/resetUnread`), //设置已读
    batchListSkuCoverList: getFun(`/ps/web/project/batch/listSkuCoverList`), //生成页面左侧SKU列表
    batchListResult: getFun(`/ps/web/project/batch/listResult`), //生成结果列表
    batchPickImage: postFun(`/ps/web/project/batch/pickImage`), //挑图
    batchListPickedResult: getFun(`/ps/web/project/batch/listPickedResult`), //挑图
    getPickedImageList: postFun(`/ps/web/project/batch/getPickedImageList`), //已选图列表（批量下载）
    regenerateByProject: postFun(`/ps/web/project/batch/regenerateByProject`), //再次发起一个新项目
    regenerateByTaskId: postFun(`/ps/web/project/batch/regenerateByTaskId`), //生成结果页再次生成
    editAndGenerate: postFun(`/ps/web/project/batch/editAndGenerate`), //生成结果页重新编辑
    batchCommonDownload: postFun(`/ps/web/project/batch/commonDownload`), //生成结果页重新编辑
    batchScoreImage: postFun(`/ps/web/project/batch/scoreImage`), //意见反馈
    batchCopySku: postFun(`/ps/web/project/batch/copySku`), //复制SKU
    batchDoImageFiner: postFun(`/ps/web/project/batch/doImageFiner`), //发起超清任务
    batchTemplates: getFun(`/ps/web/project/batch/jirui/templates`), //智能详情页模板

    // 渠道管理
    stockStatistics: getFun(`/ps/web/sales/stockStatistics`), // 库存统计数据
    activateStatistics: getFun(`/ps/web/sales/activateStatistics`), // 激活统计数据
    listPlanSelect: getFun(`/ps/web/sales/listPlanSelect`), // 套餐筛选下拉列表
    listOrderedPlan: getFun(`/ps/web/sales/listOrderedPlan`), // 兑换码列表
    salesListPlan: getFun(`/ps/web/sales/listPlan`), // 购买套餐列表
    salesPurchase: postFun(`/ps/web/sales/purchase`), // 套餐订购
    salesPaymentOrderStatus: postFun(`/ps/web/sales/paymentOrderStatus`), // 套餐订购状态查询
    salesVerifySerialKey: postFun(`/ps/web/sales/verifySerialKey`), // 序列号校验
    salesExchangePlan: postFun(`/ps/web/sales/exchangePlan`), // 兑换套餐
    listNotActivateKeys: getFun(`/ps/web/sales/listNotActivateKeys`), // 未激活序列号列表
    avgPowerAmount: postFun(`/ps/web/user/avgPowerAmount`), // 未激活序列号列表

    // 邀新人活动
    activityLadderInfo: getFun(`/ps/web/activity/ladderInfo`), //天梯榜活动信息
    ladderInvitationList: getFun(`/ps/web/activity/ladderInvitationList`), //邀请记录
    getInvitationInfo: getFun(`/ps/web/activity/getInvitationInfo`), //常规活动信息
    listNormalInviteRecords: getFun(`/ps/web/activity/listNormalInviteRecords`), //常规邀请记录
    userReadInviteMsg: postFun(`/ps/web/user/readInviteMsg`), //超过50人提醒

    // 图生视频
    doImage2Video: postFun(`/ps/web/v2/doImage2Video`),

    multiSemanticPredictionUrl: url + '/ps/web/algo/multiSemantic/',
    maskPredictionUrl: url + '/aishops/aimodel/mask/prediction/',
    maskPredictionAiclothUrl: url + '/aishops/aicloth/mask/prediction/',
    maskPredictionshoesUrl: url + '/ps/web/algo/shoesMask/',
    maskPredictionAidressformUrl: url + '/aishops/aidressform/mask/prediction/',
    maskPredictionUrlGoods: url + '/aishops/aigods/mask/prediction/',
    handlePredictionUrl: url + '/aishops/aiautocrop/handle/prediction/',
    airemovePredictionUrl: url + '/ps/web/algo/magicEraser/',
    aiinteractivePredictionUrl: url + '/aishops/aiinteractive/mask/prediction/',
    aibeautyPredictionUrl: url + "/aishops/aibeauty/handle/prediction",
    aiembeddingPredictionUrl: url + '/aishops/aiembedding/mask/prediction/',
    aisuperresolutionPredictionUrl: url + '/aishops/aisuperresolution/handle/prediction/',
    aisuperresolution4VideoPredictionUrl: url + '/ps/web/algo/videoSR/prediction/',
    aiDragGanUrl: url + '/aishops/aidraggan/handle/prediction',
    url: url,
    devBaseUrl
}